import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
const LANGUAGE_MAP: Readonly<Partial<Record<string, string>>> = {
  de: 'Deutsch',
  en: 'Englisch',
  es: 'Spanisch',
  fr: 'Französisch',
  it: 'Italienisch',
  nl: 'Niederländisch',
  ja: 'Japanisch',
  ru: 'Russisch',
  ar: 'Arabisch',
  zh: 'Chinesisch',
  da: 'Dänisch',
  el: 'Griechisch',
  he: 'Hebräisch',
  lb: 'Luxemburgisch',
  pl: 'Polnisch',
  pt: 'Portugiesisch',
  sv: 'Schwedisch',
  cs: 'Tschechisch',
  tr: 'Türkisch',
  hu: 'Ungarisch',
  uk: 'Ukrainisch'
};
export function useExperienceLanguages(languages) {
  const $ = _c(2);
  let t0;
  let t1;
  if ($[0] !== languages) {
    t1 = languages?.map(_temp).join(", ") ?? "";
    $[0] = languages;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  return t0;
}
function _temp(language) {
  return LANGUAGE_MAP[language] ?? language;
}